import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import SEO from "@/components/SEO";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog", { params: { limit: 50 } }).then(({data}) => setPosts(data)); }, []);

  return (
    <div className="container-x py-16 max-w-6xl" data-testid="blog-page">
      <SEO title="Journal — Pooja Guides, Rituals & Craftsmanship" description="Read AdiYogi Handicrafts' journal: pooja guides, brass vs bronze, care instructions, housewarming ideas and more." />
      <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-3">From the Journal</div>
      <h1 className="font-serif text-4xl md:text-6xl mb-12">Guides &amp; Rituals</h1>
      {posts.length === 0 ? <div className="text-muted-foreground">No posts yet.</div> :
        <div className="grid md:grid-cols-3 gap-6">
          {posts.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} className="border hairline rounded-xl overflow-hidden bg-white group" data-testid={`blog-card-${p.slug}`}>
              <div className="aspect-[16/10] overflow-hidden bg-muted"><img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>
              <div className="p-5">
                <div className="text-xs uppercase tracking-widest gold-text mb-2">{p.category}</div>
                <div className="font-serif text-xl leading-tight">{p.title}</div>
                <div className="text-sm text-muted-foreground mt-2 line-clamp-3">{p.excerpt}</div>
              </div>
            </Link>
          ))}
        </div>
      }
    </div>
  );
}
